import { StyledInput } from './InputLabel.styled'

interface InputLabelProps {
  value: string
  required?: boolean
  disabled?: boolean
  onChange: (value: string) => void
  onBlur?: () => void
  placeholder?: string
  className?: string
}

export const InputLabel: React.FC<InputLabelProps> = ({
  value,
  disabled = false,
  required,
  onChange,
  onBlur,
  placeholder = 'Click to edit',
  className,
}: InputLabelProps) => {
  return (
    <StyledInput
      type="text"
      value={value}
      disabled={disabled}
      required={required}
      onChange={(e) => onChange(e.target.value)}
      onBlur={onBlur}
      placeholder={disabled ? '' : placeholder}
      className={className}
    />
  )
}
